import React, { useState, useEffect, useRef } from "react";

import useTable from "../useTable";

import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";

import axios from "axios";
import moment from "moment";
import { ModalDevolverEmiEgre } from "./modalDevEmiEgreso";
import { Input } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";
import { AprobarSolicitudesdCompras } from "../comprasyalmacen/modalAprobarSolicitudCompras";

const TablaDevolverEmiEgre = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° CONTROL",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [egreso, setEgreso] = useState(null);
  const [aprobaciones] = useState();
  const [aprodetalle] = useState();
  const [norden] = useState(true);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              x.idordenpago.includes(target.value) ||
              x.idcompromiso.includes(target.value) ||
              x.razonsocial.includes(target.value) ||
              moment.utc(x.fecha)
                .format("DD/MM/YYYY")
                .toLowerCase()
                .includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
      },
    });
  };
  const seleccionarRegistros = () => {
    let endpoint = `${op.conexion
      }/api/administracion/catalogochequeaprob?dep=${6}&dev=${"0"}&idefiscal=${idefiscal}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };
  const seleccionarRegistro = (id) => {
    let endpoint = `${op.conexion}/api/administracion/selecteaprogreso?idegreso=${id}&idefiscal=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
          setEgreso(response.data);
          setMostrar2(true);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
  };
  const gestionarOrdenPago = (op, id) => (e) => {
    setOperacion(op);
    if (op === 1) {
      setMostrar2(true);
    } else {
      seleccionarRegistro(id);
    }
  };
  useEffect(() => {
    seleccionarRegistros();
    setActivate(true);
  }, []);

  const handleCancelar = () => {
    setMostrar2(false);
  };
  const cerrar = () => {
    props.setTabla(0);
  };
  return (
    <div className="col-8 m-0 p-0 mx-auto mt-5">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top text-light azulGradiant">
        <h3 className="m-0">Gestionar Devolver Pago de Emísón de Egreso</h3>
        <a type="button" onClick={cerrar}>
          salir<i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        className="col-12 m-0 p-2 d-flex justify-content-between"
      >
        <div className="col-4 m-0 p-0">
          <input
            ref={txtBuscador}
            onChange={handleSearch}
            placeholder="Buscar"
             className='search-input form-control form-control-sm'
          />
        </div>
        <PrimaryButton
          onClick={gestionarOrdenPago(1, "")}
          icon="fa-plus m-0"
        ></PrimaryButton>
      </form>
      <div>
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", alignItems: "center" }}
                  >
                    {item.idaprobacionescheque}
                  </td>
                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", alignItems: "center" }}
                  >
                    {item.observaciones}
                  </td>

                  <td
                    className="align-baseline"
                    style={{ textAlign: "center", alignItems: "center" }}
                  >
                    {moment.utc(item.fecha).format("DD/MM/YYYY")}
                  </td>

                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "100px",
                    }}
                  >
                    <button
                      onClick={gestionarOrdenPago(4, item.idaprobacionescheque)}
                      className="btn btn-sm mx-1 btn-info rounded-circle"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>

      <AprobarSolicitudesdCompras
        show={mostrar2}
        operacion={operacion}
        aprobado={aprobaciones}
        //aprobaciones={aprobacion}
        aprodetalle={aprodetalle}
        titulo={operacion === 4
          ? "Consultar Orden Pago"
          : operacion === 2
            ? "Reversar Orden Pago"
            : operacion === 1
              ? "Incluir Orden Pago"
              : "Eliminar Orden Pago"}
        onHideCancelar={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
      />
      {/* este modal se cambio por el de aprobacion de compras y alamcen */}

      <ModalDevolverEmiEgre
        // show={mostrar2}
        operacion={operacion}
        norden={norden}
        egreso={egreso}
        ubi={44}
        tip={0}
        aprobaciones={aprobaciones}
        aprodetalle={aprodetalle}
        titulo={
          operacion === 4
            ? "Consultar Orden Pago"
            : operacion === 2
              ? "Reversar Orden Pago"
              : operacion === 1
                ? "Incluir Orden Pago"
                : "Eliminar Orden Pago"
        }
        onHideCancela={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
      />
      {/*   ------------------------------------   */}

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaDevolverEmiEgre;
